module.exports = __webpack_public_path__ + "img/number5.123864a8.svg";